/* Myscha Nuit — mode lancement : accès anticipé des initiés (sans dépendance) */
(function () {
  'use strict';
  var theme = window.MyschaTheme || {};
  var cfg = theme.launch || {};
  if (!cfg.active) return;
  var t = cfg.texts || {};

  function getState() {
    var now = Date.now();
    var early = Date.parse(cfg.earlyAt);
    var pub = Date.parse(cfg.publicAt);
    if (isNaN(early) || isNaN(pub)) return 'open';
    if (now < early) return 'before';
    if (now < pub) return cfg.initie ? 'early-initie' : 'early-guest';
    return 'open';
  }
  var state = getState();
  var canBuy = state === 'open' || state === 'early-initie';
  var lockLabel = state === 'before' ? t.labelBefore : t.labelEarly;

  function note(cls, text, withLogin) {
    var p = document.createElement('p');
    p.className = cls;
    p.appendChild(document.createTextNode(text + ' '));
    if (withLogin && cfg.loginUrl) {
      var a = document.createElement('a');
      a.href = cfg.loginUrl;
      a.textContent = t.login;
      p.appendChild(a);
    }
    return p;
  }

  function lockProductForm(form) {
    var submit = form.querySelector('[data-submit]');
    var label = form.querySelector('[data-submit-label]');
    var anchor = form.querySelector('[data-error]') || submit;
    var text = state === 'before' ? t.noteBefore : state === 'early-guest' ? t.noteEarly : state === 'early-initie' ? t.noteInitie : '';
    if (text && anchor && !form.querySelector('.buy__launch')) {
      anchor.insertAdjacentElement('afterend', note('buy__launch', text, state === 'early-guest'));
    }
    if (canBuy || !submit) return;
    function lock() {
      if (!submit.disabled) submit.disabled = true;
      if (label && lockLabel && label.textContent !== lockLabel) label.textContent = lockLabel;
    }
    lock();
    new MutationObserver(lock).observe(submit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
  }

  function lockCart() {
    if (canBuy) return;
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      btn.disabled = true;
      if (t.cart && !btn.parentNode.querySelector('.cart-launch')) {
        btn.insertAdjacentElement('beforebegin', note('cart-launch', t.cart, state === 'early-guest'));
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) { el.hidden = true; });
  }

  function apply() {
    document.documentElement.setAttribute('data-launch', state);
    document.querySelectorAll('[data-launch-only]').forEach(function (el) {
      var states = el.getAttribute('data-launch-only').split(/\s+/);
      el.classList.toggle('is-launch-visible', states.indexOf(state) !== -1);
    });
    document.querySelectorAll('[data-launch-tags]').forEach(function (input) {
      input.value = state === 'before' ? input.getAttribute('data-launch-tags') : input.getAttribute('data-default-tags');
    });
    document.querySelectorAll('[data-product-form]').forEach(lockProductForm);
    lockCart();
  }

  // Bloque l'ajout au panier tant que l'achat n'est pas ouvert (avant le script du thème).
  document.addEventListener('submit', function (e) {
    if (canBuy) return;
    if (e.target.matches && e.target.matches('[data-product-form]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Bascule automatique à l'heure dite si la page reste ouverte.
  setInterval(function () { if (getState() !== state) window.location.reload(); }, 30000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
